import { Clock } from 'lucide-react';
import { Button } from '../components/ui';
import { useNavigate } from 'react-router-dom';

export default function ComingSoon({ feature }) {
  const navigate = useNavigate();
  const label = feature?.label || 'This Feature';
  const desc  = feature?.description || 'We are working on something great. Stay tuned!';
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-5 px-4 animate-slide-up">
      <div className="w-20 h-20 rounded-3xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center">
        <Clock className="w-10 h-10 text-amber-400" />
      </div>
      <div className="space-y-2 max-w-sm">
        <p className="text-xs font-bold text-amber-400 uppercase tracking-widest">Coming Soon</p>
        <h1 className="text-2xl font-black text-text-primary">{label}</h1>
        <p className="text-text-muted text-sm leading-relaxed">{desc}</p>
      </div>
      <div className="flex gap-3">
        <Button variant="secondary" onClick={() => navigate(-1)}>Go Back</Button>
        <Button onClick={() => navigate('/dashboard')}>Dashboard</Button>
      </div>
    </div>
  );
}
